<template>
  <div class="spl-save-template-bar">
    <div class="row">
      <div class="col1">
        <form-label :dark="true">
          Template name
        </form-label>
      </div>
      <div class="col4">
        <form-input :required="true" />
      </div>
      <div class="col4" />
      <div class="col3">
        <form-button :extrapadding="true" @onClick="closeSaveTemplate">
          Save
        </form-button>
        <form-button
          :extrapadding="true"
          :secondary="true"
          @onClick="closeSaveTemplate">
          Cancel
        </form-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaveTemplateBar',
  methods: {
    closeSaveTemplate () {
      this.$emit('closeSaveTemplate')
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-save-template-bar {
        background-color: $middleYellow;
        bottom: 0;
        height: 70px;
        padding: 15px $mainPadding;
        position: fixed;
        width: 100%;

        .spl-label {
            color: $darkerYellow;
            line-height: 40px;
        }
        .spl-input {
            margin-bottom: 0;
        }
        .spl-button {
            background-color: $mainInputColor;
            color: $footerButtonDarkGreyText;
            float: right;
            margin: 0 0 0 15px;

            &-secondary {
                background-color: $footerButtonYellow;
                color: $yellowButtonLabel;
            }
        }
    }
</style>
